import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import axios from 'axios';
import pkceChallenge from 'pkce-challenge';

// your existing helpers
import { Publisher } from "./../../../pubsub/publisher.js";
import { _setSSOToken, decodeIdToken } from './ssoutils';
// Helpers
function replaceDomainWithCurrent(url) {
  var originalUrl = new URL(url);
  var currentDomain = window.location.hostname;
  originalUrl.hostname = currentDomain;
  return originalUrl.href;
}

function parseQuery(search) {
  var params = {};
  if (!search) return params;
  var q = search.charAt(0) === '?' ? search.substring(1) : search;
  var parts = q.split('&');
  for (var i = 0; i < parts.length; i++) {
	var kv = parts[i].split('=');
	var k = decodeURIComponent(kv[0] || '');
	var v = decodeURIComponent(kv[1] || '');
	if (k) params[k] = v;
  }
  return params;
}

export default withRouter(class Login extends Component {
  constructor(props) {
	super(props);
	this.state = {
	  authenticated: null,
	  fetchInProgress: false,
	  authToken: false,
	  error: false,
	  errorMessage: false
	};
  }

  componentDidMount() {
	// If not on redirect, start PKCE and go to Auth0 /authorize
	if (window.location.pathname.indexOf('redirect') < 0) {
	  var codes = pkceChallenge();
	  sessionStorage.setItem('code_challenge', codes.code_challenge);
	  sessionStorage.setItem('code_verifier', codes.code_verifier);

	  var auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN; // e.g. "your-tenant.us.auth0.com"
	  var clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
	  var redirectUri = replaceDomainWithCurrent(process.env.REACT_APP_AUTH0_REDIRECT_URI);
	  var audience = process.env.REACT_APP_AUTH0_AUDIENCE || '';
	  var organization = process.env.REACT_APP_AUTH0_ORGANIZATION || '';

	  // Build /authorize URL (PKCE)
	  var authUrl = 'https://' + auth0Domain + '/authorize'
		+ '?client_id=' + encodeURIComponent(clientId)
		+ '&response_type=code'
		+ '&code_challenge=' + encodeURIComponent(codes.code_challenge)
		+ '&code_challenge_method=S256'
		+ '&redirect_uri=' + encodeURIComponent(redirectUri)
		+ '&scope=' + encodeURIComponent('openid email profile')
		+ '&state=' + encodeURIComponent('mp-' + Date.now());

	  if (audience) {
		authUrl += '&audience=' + encodeURIComponent(audience);
	  }
	  if (organization) {
		authUrl += '&organization=' + encodeURIComponent(organization);
	  }

	  // Optional niceties for “trickle sign-in”
	  // authUrl += '&prompt=login';
	  // authUrl += '&login_hint=' + encodeURIComponent(prefilledEmail);

	  window.location.href = authUrl;
	  return;
	}

	// On redirect: exchange code for tokens
	var qp = parseQuery(window.location.search);
	if (qp.error) {
	  this.setState({
		error: qp.error,
		errorMessage: qp.error_description ? qp.error_description : 'Authorization failed, please contact your support team.'
	  });
	  return;
	}
	if (qp.code) {
	  this._getAuthToken(qp.code);
	}
  }

  _getAuthToken = function (code) {
	if (!this.state.fetchInProgress) {
	  this.setState({ fetchInProgress: true });
	}

	var auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
	var clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
	var redirectUri = replaceDomainWithCurrent(process.env.REACT_APP_AUTH0_REDIRECT_URI);

	var params = new URLSearchParams();
	params.append('grant_type', 'authorization_code');
	params.append('client_id', clientId);
	params.append('code', code);
	params.append('redirect_uri', redirectUri);
	params.append('code_verifier', sessionStorage.getItem('code_verifier'));

	axios.post('https://' + auth0Domain + '/oauth/token', params)
	  .then((resp) => {
		var token = resp && resp.data ? resp.data : null;
		if (token && token.id_token) {
		  var decodedClaims = decodeIdToken(token.id_token);
		  _setSSOToken(token, 'MPSSO');

		  Publisher.publish('track-mp.userLogin.ssoTokenClaims', {
			user: {
			  id: decodedClaims.sub,
			  email: decodedClaims.email,
			  name: decodedClaims.name
			},
			customData: token
		  });

		  this.setState({ authToken: token });
		} else {
		  this.setState({ error: true, errorMessage: 'Missing id_token in token response.' });
		}
	  })
	  .catch((err) => {
		console.log('token exchange error:', err);
		this.setState({ error: true, errorMessage: 'Token exchange failed.' });
	  });
  };

  render() {
	var authToken = this.state.authToken;
	var error = this.state.error;
	if (authToken) {
	  return <Redirect to={{ pathname: `/` }} />;
	}
	if (window.location.href.indexOf('sso') >= 0 && !error) return null;
	return (
	  <div className="plan__wrapper share__wrapper"></div>
	);
  }
});
